import { RawAnchor } from '@components/anchor'
import { AppStoreRating } from '@components/app-store-rating'
import { ContentfulImage } from '@components/contentful-image'
import { Container } from '@components/layout/grid'
import type { SectionOfPressBannersFragment } from '@graphql/fragments/SectionOfPressBannersFragment.graphql'
import variables, { type Variable } from '@styles/variables'
import type { FunctionComponent } from 'react'

import styles from './section-of-press-banners.module.scss'

export const SectionOfPressBanners: FunctionComponent<
    SectionOfPressBannersFragment
> = ({
    icons,
    appStoreRating,
    numberOfReviews,
    backgroundColor = 'darkGray',
    appRating,
}) => {
    const rating = appRating?.starRating ?? appStoreRating
    const reviewCount = appRating?.reviewCount ?? numberOfReviews
    return (
        <div
            className={styles.section}
            style={{ backgroundColor: variables[backgroundColor as Variable] }}
        >
            <Container className={styles.content}>
                <div className={styles.logos}>
                    {(icons?.items ?? []).map(
                        ({ sys: { id }, action, image }) => {
                            const icon = image?.svgSource ? (
                                <ContentfulImage
                                    url={image.svgSource}
                                    alt={image?.alt}
                                    width={image.width ?? 340}
                                    height={image.height ?? 40}
                                    contentType={image.contentType}
                                    sizes='340px'
                                    className={styles.logo}
                                />
                            ) : null

                            if (!action || !('url' in action)) {
                                return (
                                    <div className={styles.link} key={id}>
                                        {icon}
                                    </div>
                                )
                            }

                            return (
                                <RawAnchor
                                    key={id}
                                    href={action.url}
                                    target={id}
                                    className={styles.link}
                                >
                                    {icon}
                                </RawAnchor>
                            )
                        },
                    )}

                    {rating && reviewCount && (
                        <div className={styles.rating}>
                            <AppStoreRating
                                value={rating}
                                numberOfReviews={reviewCount}
                            />
                        </div>
                    )}
                </div>
            </Container>
        </div>
    )
}

export default SectionOfPressBanners
